import { Amount } from "src/components/Amount";
import { Session } from "../../types/session.entity";
import { displayDate } from "src/utils/dateHandler.util";
import { Badge } from "src/components/Badge/Badge";
import { formatScreamingSnakeCase, languageMap } from "src/utils/util";
import { sessionStateStyles, sessionTypeIcons, sessionTypeStyles } from "../../utils/session-styles";
import { MenuActions } from "src/components/menu-actions";
import { useLocation } from "react-router-dom";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";

type Props = {
  data: Session[];
};
export const SessionsTable = ({ data }: Props) => {
  const { search } = useLocation();

  return (
    <div>
      <div className="overflow-x-auto mb-6">
        <table className="min-w-full border border-gray-200 divide-y divide-gray-200">
          <thead className="bg-gray-800 text-white text-center">
            <tr>
              <th className="px-4 py-3">Id</th>
              <th className="px-4 py-3">Language</th>
              <th className="px-4 py-3">Start At</th>
              <th className="px-4 py-3">Duration Minutes</th>
              <th className="px-4 py-3">Type</th>
              <th className="px-4 py-3">State</th>
              <th className="px-4 py-3">Amount</th>
              <th className="px-4 py-3">View</th>
            </tr>
          </thead>

          <tbody>
            {data.map((session) => (
              <tr key={session.id} className="text-center odd:bg-white even:bg-gray-50 hover:bg-gray-100">
                <td className="px-4 py-3 border-t border-gray-200 max-w-xs whitespace-nowrap overflow-hidden text-ellipsis">
                  {session.id}
                </td>
                <td className="px-4 py-3 border-t border-gray-200">{languageMap[session.langCode]}</td>
                <td className="px-4 py-3 border-t border-gray-200">{displayDate(session.startTime) ?? "__"}</td>
                <td className="px-4 py-3 border-t border-gray-200">{session.totalDurationMins ?? "__"}</td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Badge
                    label={formatScreamingSnakeCase(session.type)}
                    classes={sessionTypeStyles[session.type]}
                    icon={sessionTypeIcons[session.type]}
                  />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Badge label={formatScreamingSnakeCase(session.state)} classes={sessionStateStyles[session.state]} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">
                  {session.coachEarnedBalance ? (
                    <Amount amount={session.coachEarnedBalance.amount} currency={session.coachEarnedBalance.currency} />
                  ) : (
                    "__"
                  )}
                </td>

                <td className="px-4 py-3 border-t border-gray-200">
                  <MenuActions actions={[{ type: "LINK", to: appendSearchToPath(`/sessions/${session.id}`, search), label: "view" }]} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {data.length === 0 && <p className="px-4 py-3 text-center text-gray-500">No Sessions Found</p>}
    </div>
  );
};
